var $6e578cb07f661d0f$exports = {};
$6e578cb07f661d0f$exports = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};


export {$6e578cb07f661d0f$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
